import { Err, Result } from "@siteimprove/alfa-result";
import { Token } from "../../../../syntax/index.js";
import { Keyword } from "../../../textual/keyword.js";
import { Length } from "../../../numeric/index.js";
import { Value } from "../../../value.js";
/**
 * {@link https://drafts.csswg.org/css-images/#valdef-ending-shape-circle}
 *
 * @internal
 */
export class Circle extends Value {
    static of(radius) {
        return new Circle(radius);
    }
    _radius;
    constructor(radius) {
        super("circle", Value.hasCalculation(radius));
        this._radius = radius;
    }
    get radius() {
        return this._radius;
    }
    resolve(resolver) {
        return new Circle(this._radius.resolve(resolver));
    }
    equals(value) {
        return value instanceof Circle && value._radius.equals(this._radius);
    }
    hash(hash) {
        hash.writeHashable(this._radius);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            radius: this._radius.toJSON(),
        };
    }
    toString() {
        return `circle ${this._radius}`;
    }
}
/**
 * @internal
 */
(function (Circle) {
    const parseShape = Keyword.parse("circle");
    const parseRadius = Length.parse;
    Circle.parse = (input) => {
        let shape;
        let radius;
        while (true) {
            for ([input] of Token.parseWhitespace(input)) {
            }
            if (shape === undefined) {
                const result = parseShape(input);
                if (result.isOk()) {
                    [input, shape] = result.get();
                    continue;
                }
            }
            if (radius === undefined) {
                const result = parseRadius(input);
                if (result.isOk()) {
                    [input, radius] = result.get();
                    continue;
                }
            }
            break;
        }
        if (radius === undefined) {
            return Err.of(`Expected circle radius`);
        }
        return Result.of([input, Circle.of(radius)]);
    };
})(Circle || (Circle = {}));
//# sourceMappingURL=circle.js.map